import Encoding from "encoding-japanese";
import i18n from "utils/i18n";

// エラータイプCD
const ERROR_TYPE_CD = {
  REQUIRED: "001",
  FORMAT: "002",
  PASSWORD_SAME: "003",
};

// 名称のデフォルト最大文字数
const DEFAULT_MAX_NAME_LENGTH = 20;
// パスワードサイズ
const DEFAULT_MIN_PASSWORD_LENGTH = 8;
const DEFAULT_MAX_PASSWORD_LENGTH = 20;
const DEFAULT_MAX_FILE_SIZE_MB = 2;
// 住所テキスト
const MAX_TOWN_TEXT_LENGTH = 20;
const MAX_STREET_TEXT_LENGTH = 20;
const MAX_BUILDING_TEXT_LENGTH = 20;
// 共通パラメータ
const MAX_NOTIFICATION_TITLE_LENGTH = 20;

// 基本クラス Point
class ValidationResultItem {
  // コンストラクタ
  /* eslint-disable no-unused-expressions */
  constructor(errorCd = "", errorMsg = "") {
    this._errorCd = errorCd;
    this._errorMsg = errorMsg;
  }
  /* eslint-enable */

  get errorCd() {
    return this._errorCd;
  }

  set errorCd(value) {
    this._errorCd = value;
  }

  // TODO: この記述方法で良いのか確認する。
  get errorMsg() {
    return this._errorMsg;
  }

  set errorMsg(value) {
    this._errorMsg = value;
  }
}

// 基本クラス Point
class Validator {
  // コンストラクタ
  /* eslint-disable no-unused-expressions */
  constructor(screenCd = "99") {
    this._result = true;
    this._errors = {};

    this._screenCd = screenCd;
  }
  /* eslint-enable */

  get result() {
    return this._result;
  }

  set result(value) {
    this._result = value;
  }

  // TODO: この記述方法で良いのか確認する。
  get errors() {
    return this._errors;
  }

  set errors(value) {
    this._errors = value;
  }

  get screenCd() {
    return this._screenCd;
  }

  set screenCd(value) {
    this._screenCd = value;
  }

  // Util関数
  static isEmpty(val) {
    return val === "" || val === null || val === undefined;
  }

  static isAlphaNumOnly(val) {
    const check = /^[a-zA-Z0-9]*$/i;
    return check.test(val);
  }

  static isEmail(val) {
    const check = /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/i;
    return check.test(val) && !val.match(/\.\./);
  }

  static isPhoneNumber(val) {
    const check = /^(0[5-9]0-?[0-9]{4}-?[0-9]{4}|0[0-9]{1}-?[0-9]{4}-?[0-9]{4}|0[0-9]{2}-?[0-9]{3}-?[0-9]{4}|0[0-9]{3}-?[0-9]{2}-?[0-9]{4}|0[0-9]{4}-?[0-9]{1}-?[0-9]{4})$/i;
    return check.test(val);
  }

  static isJisX0208(val) {
    let res = true;
    try {
      // ios-2022-jpにエンコードを試みる
      Encoding.stringToCode(val).forEach((char) => {
        // sjisに変換
        const sjisArray = Encoding.convert([char], {
          to: "SJIS",
          from: "UNICODE",
        }).map((code) => code.toString(16).toUpperCase());

        if (sjisArray.length === 1) {
          const sjisCode = `00${sjisArray[0]}`.slice(-2);
          // 1バイト文字
          if (sjisCode < "00" && sjisCode > "FF") res = false;
          else if (
            (sjisCode >= "80" && sjisCode <= "A0")
            || (sjisCode >= "E0" && sjisCode <= "FF")
          ) res = false;
        } else if (sjisArray.length === 2) {
          // 2バイト文字
          const twoByteCode = sjisArray.join("");
          if (twoByteCode < "8140" && twoByteCode > "EFFC") res = false;
          else if (
            // 01/02　区
            (sjisArray[0] === "81" && sjisArray[1] >= "AD" && sjisArray[1] <= "B7")
            || (sjisArray[0] === "81" && sjisArray[1] >= "C0" && sjisArray[1] <= "C7")
            || (sjisArray[0] === "81" && sjisArray[1] >= "CF" && sjisArray[1] <= "D9")
            || (sjisArray[0] === "81" && sjisArray[1] >= "E9" && sjisArray[1] <= "EF")
            || (sjisArray[0] === "81" && sjisArray[1] >= "F8" && sjisArray[1] <= "FB")
            // 03/04　区
            || (sjisArray[0] === "82" && sjisArray[1] >= "40" && sjisArray[1] <= "4E")
            || (sjisArray[0] === "82" && sjisArray[1] >= "59" && sjisArray[1] <= "5F")
            || (sjisArray[0] === "82" && sjisArray[1] >= "7A" && sjisArray[1] <= "80")
            || (sjisArray[0] === "82" && sjisArray[1] >= "9B" && sjisArray[1] <= "9E")
            || (sjisArray[0] === "82" && sjisArray[1] >= "F2" && sjisArray[1] <= "FC")
            // 05/06　区
            || (sjisArray[0] === "83" && sjisArray[1] >= "97" && sjisArray[1] <= "9E")
            || (sjisArray[0] === "83" && sjisArray[1] >= "B7" && sjisArray[1] <= "BE")
            || (sjisArray[0] === "83" && sjisArray[1] >= "D7" && sjisArray[1] <= "FC")
            // 07/08 区
            || (sjisArray[0] === "84" && sjisArray[1] >= "61" && sjisArray[1] <= "6F")
            || (sjisArray[0] === "84" && sjisArray[1] >= "92" && sjisArray[1] <= "9E")
            || (sjisArray[0] === "84" && sjisArray[1] >= "BF" && sjisArray[1] <= "FC")
            // 09-16 区
            || (twoByteCode >= "8540" && twoByteCode <= "889E")
            // 47/48 区
            || (sjisArray[0] === "98" && sjisArray[1] >= "73" && sjisArray[1] <= "9E")
            // 83-94区
            || (twoByteCode >= "EAA5" && twoByteCode <= "EFFC")
          ) res = false;
        } else {
          // 3バイト以上文字は存在しないため、エラーとみなす
          res = false;
        }
        return res;
      });
    } catch (e) {
      console.log(e);
      res = false;
    }
    return res;
  }

  // 環境依存文字のチェック
  static includeEnvironmentDependentCharacters(val) {
    let res = false;
    const check = "[①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡㍻〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼]";
    if (val && check.match(val)) {
      res = true;
    }
    if (val && !Validator.isJisX0208(val)) {
      res = true;
    }
    if (val && [...val].length !== val.length) {
      res = true;
    }
    return res;
  }

  //　エラーコード生成
  getErrorCd(itemCd, errorTypeCd) {
    return `${this.screenCd}${itemCd}${errorTypeCd}`;
  }

  // エラーアイテムを追加
  pushValidationResultItem(key, errorCd, errorMsg) {
    if (!this.errors[key]) {
      this.errors[key] = [];
    }
    this.errors[key].push(new ValidationResultItem(errorCd, errorMsg));
  }

  // エラーメッセージの参照
  getErrorMsg(key, index = 0) {
    let errorMsg = "";
    if (this.errors[key] && this.errors[key].length > index) {
      errorMsg = this.errors[key][index].errorMsg;
    }
    return errorMsg;
  }

  /* バリデーション関数 */
  // メールチェック
  checkEmail(key, val, attributeName, itemCd, {
    required = true,
  } = {}) {
    const checkVal = val || "";

    // 必須チェック
    if (!required || Validator.isEmpty(checkVal)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.required", { attribute: attributeName }),
      );
    }

    // 書式チェック
    if (!Validator.isEmail(checkVal)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.email.format", { attribute: attributeName }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }

  checkNotificationTitle(key, val, attributeName, itemCd, {
    required = true,
  } = {}) {
    const checkVal = val || "";
    // 必須チェック
    if (required && Validator.isEmpty(checkVal)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.required", { attribute: attributeName }),
      );
    }

    if (val.length > MAX_NOTIFICATION_TITLE_LENGTH) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.max.string", {
          attribute: attributeName,
          max: MAX_NOTIFICATION_TITLE_LENGTH,
        }),
      );
    }

    // 環境依存文字のチェック
    if (Validator.includeEnvironmentDependentCharacters(val)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.character.environmentDependent", {
          attribute: attributeName,
        }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }

  // 必須名
  checkRequired(key, val, attributeName, itemCd) {
    // 必須チェック
    if (Validator.isEmpty(val)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.required", { attribute: attributeName }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }

  // 必須名
  checkEquqls(key, val1, val2, attributeName, itemCd) {
    // 必須チェック
    if (val1 === val2) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.equals", { attribute: attributeName }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }

  // ファイルサイズ
  checkFileSize(key, file, attributeName, itemCd, {
    maxFileSizeMb = DEFAULT_MAX_FILE_SIZE_MB,
  } = {}) {
    // 必須チェック
    if (!Validator.isEmpty(file) && file.size / (1024 * 1024) > maxFileSizeMb) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.fileSizeMb", {
          attribute: attributeName,
          max: maxFileSizeMb,
        }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }

  static getFileExt(fileName) {
    const extPos = fileName.lastIndexOf(".");
    if (extPos === -1) return "";
    return fileName.slice(extPos + 1);
  }

  checkFileExt(key, file, allowExts, attributeName, itemCd) {
    const fileName = file.name.toLowerCase();
    const fileExt = Validator.getFileExt(fileName);
    if (allowExts.indexOf(fileExt) === -1) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.fileSizeExt", {
          attribute: attributeName,
        }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }

  // アカウント名
  checkText(key, val, attributeName, itemCd, {
    maxSize = DEFAULT_MAX_NAME_LENGTH,
    required = true,
  } = {}) {
    // 必須チェック
    if (required && Validator.isEmpty(val)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.required", { attribute: attributeName }),
      );
    }

    // 最大文字数チェック
    if (val.length > maxSize) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.max.string", {
          attribute: attributeName,
          max: maxSize,
        }),
      );
    }

    // 環境依存文字のチェック
    if (Validator.includeEnvironmentDependentCharacters(val)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.character.environmentDependent", {
          attribute: attributeName,
        }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }

  // アカウント名
  checkName(key, val, attributeName, itemCd, {
    maxSize = DEFAULT_MAX_NAME_LENGTH,
    required = true,
  } = {}) {
    // 必須チェック
    if (required && Validator.isEmpty(val)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.required", { attribute: attributeName }),
      );
    }

    // 最大文字数チェック
    if (val && val.length > maxSize) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.max.string", {
          attribute: attributeName,
          max: maxSize,
        }),
      );
    }

    // 環境依存文字のチェック
    if (Validator.includeEnvironmentDependentCharacters(val)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.character.environmentDependent", {
          attribute: attributeName,
        }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }

  // パスワード
  checkPassword(key, val1, val2, attributeName, itemCd) {
    // 必須チェック
    if (Validator.isEmpty(val1)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.required", { attribute: attributeName }),
      );
    }

    // パスワード一致
    if (val1 !== val2) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.PASSWORD_SAME),
        i18n.global.t("validation.password.same", { attribute: attributeName }),
      );
    }

    // 最小長
    if (val1.length < DEFAULT_MIN_PASSWORD_LENGTH) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.min.string", {
          attribute: attributeName,
          min: DEFAULT_MIN_PASSWORD_LENGTH,
        }),
      );
    }

    // 最大長
    if (val1.length > DEFAULT_MAX_PASSWORD_LENGTH) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.max.string", {
          attribute: attributeName,
          max: DEFAULT_MAX_PASSWORD_LENGTH,
        }),
      );
    }

    // 半角英数記号のみ
    if (!/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/.test(val1)) {
      // if (!/[a-z]/.test(val1) || !/[A-Z]/.test(val1) || !/[0-9]/.test(val1)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.password.formatRule1", { attribute: attributeName }),
      );
    }

    // 数字、大文字、小文字を含む
    if (!/[a-z]/.test(val1)) {
      // if (!/[a-z]/.test(val1) || !/[A-Z]/.test(val1) || !/[0-9]/.test(val1)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.password.lowercase", { attribute: attributeName }),
      );
    }

    // 数字、大文字、小文字を含む
    if (!/[A-Z]/.test(val1)) {
      // if (!/[a-z]/.test(val1) || !/[A-Z]/.test(val1) || !/[0-9]/.test(val1)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.password.uppercase", { attribute: attributeName }),
      );
    }

    // 数字、大文字、小文字を含む
    if (!/[0-9]/.test(val1)) {
      // if (!/[a-z]/.test(val1) || !/[A-Z]/.test(val1) || !/[0-9]/.test(val1)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.password.number", { attribute: attributeName }),
      );
    }
    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }

  // 郵便番号
  checkPostalCode(key, val, attributeName, itemCd) {
    // 必須チェック
    if (Validator.isEmpty(val)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.required", { attribute: attributeName }),
      );
    }

    // フォーマット
    if (!Validator.isEmpty(val) && !val.match(/^[0-9]{3}-?[0-9]{4}$/)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.phoneNumber.format", { attribute: attributeName }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }

  // 都道府県
  checkStateName(key, val, attributeName, itemCd) {
    // 必須チェック
    if (Validator.isEmpty(val)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.required", { attribute: attributeName }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }

  // 市区町村
  checkTownName(key, val, attributeName, itemCd) {
    // 必須チェック
    if (Validator.isEmpty(val)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.required", { attribute: attributeName }),
      );
    }

    if (val.length > MAX_TOWN_TEXT_LENGTH) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.max.string", {
          attribute: attributeName,
          max: MAX_TOWN_TEXT_LENGTH,
        }),
      );
    }

    // 環境依存文字のチェック
    if (Validator.includeEnvironmentDependentCharacters(val)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.character.environmentDependent", {
          attribute: attributeName,
        }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }

  // 番地
  checkStreetText(key, val, attributeName, itemCd) {
    // 必須チェック
    if (Validator.isEmpty(val)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.required", { attribute: attributeName }),
      );
    }

    if (val.length > MAX_STREET_TEXT_LENGTH) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.max.string", {
          attribute: attributeName,
          max: MAX_STREET_TEXT_LENGTH,
        }),
      );
    }

    // 環境依存文字のチェック
    if (Validator.includeEnvironmentDependentCharacters(val)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.character.environmentDependent", {
          attribute: attributeName,
        }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }

  // 建物名
  checkBuildingText(key, val, attributeName, itemCd) {
    if (val.length > MAX_BUILDING_TEXT_LENGTH) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.max.string", {
          attribute: attributeName,
          max: MAX_BUILDING_TEXT_LENGTH,
        }),
      );
    }

    // 環境依存文字のチェック
    if (Validator.includeEnvironmentDependentCharacters(val)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.character.environmentDependent", {
          attribute: attributeName,
        }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }

  // 電話番号
  checkPhoneNumber(key, val, attributeName, itemCd, {
    required = true,
  } = {}) {
    // 必須チェック
    if (!required || Validator.isEmpty(val)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.REQUIRED),
        i18n.global.t("validation.required", { attribute: attributeName }),
      );
    }
    // 書式
    if (!Validator.isPhoneNumber(val)) {
      this.pushValidationResultItem(
        key,
        this.getErrorCd(this.screenCd, itemCd, ERROR_TYPE_CD.FORMAT),
        i18n.global.t("validation.phoneNumber.format", { attribute: attributeName }),
      );
    }

    // バリデーション結果
    if (this.getErrorMsg(key) !== "") {
      this.result = false;
    }
  }
}

export {
  Validator,
  ValidationResultItem,
  ERROR_TYPE_CD,
};
